import React, { PureComponent } from 'react'
import { hitTestReferenceLine } from '../../utils/scoutReferenceLines'

/**
 * Overlay SVG de líneas de referencia sobre el Scout.
 * Desacoplado del canvas Cornerstone / Vol3D.
 */
export default class ReferenceLinesOverlay extends PureComponent {
  handleClick = (e) => {
    const { lines, imageWidth, imageHeight, onLineClick } = this.props
    if (!onLineClick || !lines || !lines.length) return
    const svg = e.currentTarget
    const rect = svg.getBoundingClientRect()
    if (!rect.width || !rect.height || !imageWidth || !imageHeight) return
    const x = ((e.clientX - rect.left) / rect.width) * imageWidth
    const y = ((e.clientY - rect.top) / rect.height) * imageHeight
    const hit = hitTestReferenceLine(lines, x, y, Math.max(10, imageWidth * 0.02))
    if (hit) onLineClick(hit.index, hit)
  }

  render() {
    const {
      lines = [],
      activeIndex = -1,
      imageWidth = 1,
      imageHeight = 1,
      visible = true,
    } = this.props

    if (!visible) return null

    return (
      <svg
        className="scout-reference-lines-overlay"
        viewBox={`0 0 ${imageWidth} ${imageHeight}`}
        preserveAspectRatio="none"
        onClick={this.handleClick}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          pointerEvents: 'auto',
          zIndex: 12,
        }}
      >
        {lines.map((line) => {
          const active = line.index === activeIndex
          return (
            <g key={`rl-${line.index}`}>
              <line
                x1={line.x1}
                y1={line.y1}
                x2={line.x2}
                y2={line.y2}
                stroke={active ? '#ffcc33' : 'rgba(0, 200, 255, 0.55)'}
                strokeWidth={active ? Math.max(imageWidth, imageHeight) * 0.004 : Math.max(imageWidth, imageHeight) * 0.002}
                vectorEffect="non-scaling-stroke"
              />
              {(active || line.index % 5 === 0) && (
                <text
                  x={(line.x1 + line.x2) / 2}
                  y={(line.y1 + line.y2) / 2}
                  fill={active ? '#ffcc33' : 'rgba(180, 230, 255, 0.85)'}
                  fontSize={Math.max(10, Math.min(imageWidth, imageHeight) * 0.035)}
                  style={{ userSelect: 'none', pointerEvents: 'none' }}
                >
                  {line.index + 1}
                </text>
              )}
            </g>
          )
        })}
      </svg>
    )
  }
}
